import type { IStrategy } from "@pulse-ui/codegen/generated_ts/org_entity";
import { api } from "../base";

const strategyEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Fetches all strategies. */
    getStrategies: build.query<IStrategy[], void>({
      query: () => ({ url: "/api/entity/v1/strategies" }),
      providesTags: ["Strategies"],
    }),

    /** Creates a new strategy. */
    createStrategy: build.mutation<void, { display_name: string }>({
      query: (body) => ({
        url: "/api/entity/v1/strategies",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Strategies"],
    }),

    /** Deletes a strategy by ID. */
    deleteStrategy: build.mutation<void, string>({
      query: (strategyId) => ({
        url: `/api/entity/v1/strategies/${strategyId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Strategies"],
    }),
  }),
});

export const {
  useGetStrategiesQuery,
  useCreateStrategyMutation,
  useDeleteStrategyMutation,
} = strategyEndpoints;
